<template>
  <div class="content-wrapper">
    <div class="content-container">
      <!-- <div class="content-header">
        <h3>Danh sách đơn OT</h3>
      </div> -->
      <div class="tab-action">
        <div class="tab-action-wrapper">
          <router-link :to="{ name: 'Overtime Request', params: {} }">
            <div :class="tab === 1 ? ['tab-active', 'tab-ml'] : ''">
              Của tôi
              <span class="badge badge-info badge-pill" v-if="totalOverTimeRequest.totalMyOverTimeRequest > 0">
                {{ totalOverTimeRequest.totalMyOverTimeRequest }}
              </span>
            </div>
          </router-link>
          <router-link :to="{ name: 'Overtime Request Approval', params: {} }">
            <div :class="tab === 2 ? ['tab-active', 'tab-mr'] : ''">
              Cần duyệt
              <span class="badge badge-info badge-pill" v-if="totalOverTimeRequest.totalMyOverTimeAppRequest > 0">
                {{ totalOverTimeRequest.totalMyOverTimeAppRequest }}
              </span>
            </div>
          </router-link>
        </div>
        <div class="tab-button">
          <div>
            <slot name="button-group"></slot>
          </div>
          <!-- <router-link :to="{ name: 'Employee Overtime Create', params: {} }"> -->
          <slot name="button-create"></slot>

          <!-- </router-link> -->
        </div>
      </div>
    </div>
    <slot name="data-table"></slot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ProjectDetailLayout",
  props: {
    tab: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters({
      totalOverTimeRequest: "overtime-request/totalOverTimeRequest",
    }),
  },

  methods: {
    openModal() {
      this.$refs.create.showModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.content-wrapper {
  padding: 10px 24px;
  background: #ffffff;
  .content-container {
    .content-header {
      h3 {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;

        color: #3d4cdc;
      }
    }

    .tab-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      @media only screen and (max-width: 576px) {
        flex-direction: column;
        row-gap: 10px;
      }

      .tab-action-wrapper {
        display: flex;
        background: #eeeeee;
        border-radius: 10px;
        width: 284px;
        a {
          flex: 1 1 50%;
          color: #303c54;
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: unset;
          }

          div {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            // padding: 10px 0;
            height: 40px;
            border-radius: 10px;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            width: 100%;
            text-align: center;
          }

          div.tab-active {
            background: #ffffff;
            box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.14);
            color: #303c54;
            font-weight: bold;
            height: 36px;
            width: 100%;
          }

          div.tab-ml {
            margin-left: 2px;
          }

          div.tab-mr {
            margin-right: 2px;
          }
        }
        .badge{
          margin-left: 3px;
        }
      }

      .tab-button {
        display: flex;
        align-items: center;
        column-gap: 8px;
        // a {
        //   &:hover {
        //     text-decoration: unset;
        //   }

        // }
      }
    }

    hr {
      border: 1px solid #cfcfcf;
      margin-right: 30px;
      margin-left: 30px;
    }
  }
}

/deep/ .modal-dialog {
  max-width: 36%;
  width: 36%;
}
.badge-pill {
 margin-left: 5px;
}
</style>
